module.exports = __webpack_public_path__ + "img/ic_housing_bureau_international.e0a0ad1d.svg";